import React from 'react';
import { Link } from 'react-router-dom';

function JklMark() {
  return (
    <span className="inside-keymark" aria-hidden="true">
      <i>J</i><i>K</i><i>L</i>
    </span>
  );
}

export default function InsideHeader({ compact = false }) {
  return (
    <header className={`inside-header${compact ? ' inside-header--compact' : ''}`}>
      <Link to="/inside" className="inside-brand" aria-label="JKL Inside — Archivio">
        <JklMark />
        <span className="inside-brand-slash">/</span>
        <span className="inside-brand-inside">INSIDE</span>
      </Link>
      <nav className="inside-nav" aria-label="Navigazione Inside">
        <Link to="/inside#archivio">Articoli</Link>
        <a href="/">The Private Network</a>
      </nav>
    </header>
  );
}
